import React from 'react';
import AppBar from '../Appbar/Appbar';

class Header extends React.Component {
  render() {
    return (
      <AppBar userProfile={this.props.userProfile} />
    )
  }
}

export default Header;